import React from 'react';
import Draggable from 'react-draggable';
import info_icon from "../icons/msg_information-0.png";
import warning_icon from "../icons/msg_error-0.png";
import '../desktop-components-css/Window.css';

class SecondaryWindow extends React.Component {
  constructor(props) {
    super(props);
    let componentSize = this.props.appObject.size;
    let componentWidth = componentSize[0];
    let componentHeight = componentSize[1];
    this.state = {
      windowTitle: this.props.appObject.name,
      currentSize: {
        width: componentWidth,
        height: componentHeight,
      },
      currentPosition: {
        x: (this.props.desktopSize.width / 2) - (componentWidth / 2),
        y: (this.props.desktopSize.height / 2) - (componentHeight),
      }
    };
  }

  render() {
    return (
      <Draggable
          handle="#topBarInfo"
          bounds="#screen"
          defaultPosition={this.state.currentPosition}>
        <div id="appWindow"
            data-testid = "main-window"
            style = {{
            zIndex: this.props.zIndex,
            width: this.props.appObject.size[0] + "px"
          }}>
          <div id="handle" data-testid = "top-window">
            <AppTopbar
              icon = {this.props.appObject.smallIcon}
              windowTitle = {this.state.windowTitle}
              appIndex = {this.props.arrayIndex}
              currentWidth={this.props.appObject.size[0]}
              appExitHandler = {this.props.appExitHandler}
            />
          </div>
          <div id="appInside"
            data-testid = "inside-window"
            style = {{
              width: this.props.appObject.size[0] + "px",
              height: this.props.appObject.size[1] + "px"
            }}>
              <this.props.appObject.component
                appLauncherHandler = {this.props.appLauncherHandler}
                appIndex = {this.props.arrayIndex}
                appExitHandler = {this.props.appExitHandler}
                filename = {this.props.filename}
                propMethod = {this.props.propMethod}
                info_icon = {info_icon}
                warning_icon = {warning_icon}
              />
          </div>
        </div>
      </Draggable>
    );
  }
}

function AppTopbar(props) {
  return (
    <div id="topBar"
      style = {{
        width: props.currentWidth - 10 + "px",
      }}>
      <div id="topBarInfo" data-testid = "topbar-info">
        <img src={props.icon} draggable="false" alt={props.windowTitle}/>
        <p>{props.windowTitle}</p>
      </div>
      <div id="topBarButtons" data-testid = "topbar-buttons">
        <button onClick = {e => props.appExitHandler(e, props.appIndex)}>X</button>
      </div>
    </div>
  );
}

export default SecondaryWindow;
